import { CG } from 'contexts';
import useCXI from 'modules/cxi/useCXI';
import React, { useContext } from 'react';
import * as Styled from './StyledCompanySubscription';

export const CompanySubscription = () => {
    const { state } = useContext(CG);
    const { vars } = useCXI();
    const { company } = vars;

    // cxiDeadline is stored as UTC midnight; format in UTC so the day
    // doesn't shift back in western timezones.
    const formattedDate = new Date(company?.cxiDeadline).toLocaleDateString(state.language, {
        timeZone: 'UTC',
    });

    return !company?.cxiDeadline ? null : (
        <Styled.CompanySubscription>
            Licença de uso da <strong>100 Open Startups</strong> expira em:{' '}
            <strong>{formattedDate}</strong>.
        </Styled.CompanySubscription>
    );
};
